import * as React from "react";
import { Box, TextField, Typography } from "@mui/material";
import { FormProvider, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { useMutation } from "@tanstack/react-query";
import toast from "react-hot-toast";

import { objectToFormData } from "../../../utils";
import { sendForgotPasswordlink } from "../../../sevices/apiAuth";
import GraphicElements from "../../../styles/svg/graphic_elements.svg";
import Logo from "../../../styles/svg/sofmenLogo.svg";
import { useResponsive } from "../../../hooks/useResponsive";
import mobileBg from "../../../styles/svg/login_bg_mobile.svg";
import "./forgotPassword.scss";
import SendLinkConfirmation from "./SendLinkConfirmation";
import ForgotPasswordMessage from "../../../utils/Enums";
import { useAssets } from "../../../utils/reactQuery/domainAssets";
import { getAPIBaseUrl } from "../../../utils/constants";
import TenantSiteName from "../../../components/TenantSiteName";
import useToastPromise from "../../../hooks/useToast";
import { CustomButton } from "../../../components/Button/Button";
import { RFHTextField } from "../../../components/RFH";
import { yupResolver } from "@hookform/resolvers/yup";
import { forgotPasswordSchema } from "../../../schemas/forgetPassword";

function ForgotPassword() {
  const navigate = useNavigate();

  const [showSuccess, setShowSuccess] = React.useState(false);
  const { register, handleSubmit, ...methods } = useForm({
    resolver: yupResolver(forgotPasswordSchema),
    defaultValues: {},
  });
  const isMobile = useResponsive("down", "md");
  const { logo } = useAssets();
  const apiUrl = getAPIBaseUrl();
  const { showToastPromise } = useToastPromise();

  const { mutate: forgetPassword, isLoading } = useMutation({
    mutationFn: async (data) => {
      return await showToastPromise(sendForgotPasswordlink, data);
    },
    onSuccess: (res) => {
      //toast.success(res?.data?.message);
      setShowSuccess(true);
    },
    onError: (error) => {
      console.error("An error occurred while creating task", error);
      //toast.error(error?.response?.data?.message);
    },
  });

  const submitData = (data) => {
    const formData = objectToFormData(data);
    forgetPassword(formData);
  };

  function onError(errors) {
    console.log(errors);
  }

  return (
    <Box
      component="main"
      className="forgotpassword-box"
      sx={{
        backgroundImage: `url(${isMobile ? mobileBg : GraphicElements})`,
      }}
      disableGutters={true}
    >
      <Box className="forgotpassword-innerBox">
        {logo ? (
          <img
            src={`${apiUrl}/${logo}`}
            alt="not found"
            width={isMobile ? 251 : ""}
            className="login_logo"
          />
        ) : (
          <TenantSiteName />
        )}
        {showSuccess ? (
          <SendLinkConfirmation />
        ) : (
          <FormProvider {...methods}>
            <Box
              component="form"
              onSubmit={handleSubmit(submitData, onError)}
              noValidate
              className="submitForm-box"
            >
              <Typography
                className="text-center black-primary-color mb-4 weight-700"
                component={"h1"}
                variant="h5"
              >
                {ForgotPasswordMessage.FORGOT_PASSWORD}
              </Typography>
              <Typography
                className="text-center forgot-password-para mb-4"
                variant="body1"
              >
                {ForgotPasswordMessage.FORGOT_PASSWORD_MESSAGE}
              </Typography>
              <RFHTextField
                margin="normal"
                required
                fullWidth
                id="email"
                label={"Email Address"}
                name="email"
                type="email"
                autoComplete="email"
                className="primary-input-field"
                autoFocus
                defaultPadding={false}
              />
              {/* <TextField
                margin="normal"
                required
                fullWidth
                id="email"
                label={"Email Address"}
                name="email"
                type="email"
                error={errors?.email ? true : false}
                helperText={errors?.email && errors.email.message}
                autoComplete="email"
                autoFocus
                {...register("email", {
                  required: "Email is required",
                  validate: {
                    isValidEmail: (value) =>
                      isEmail(value) || "Please enter a valid email address",
                  },
                })}
                className="primary-input-field"
              /> */}

              <CustomButton
                type="submit"
                fullWidth
                variant="contained"
                className="btn-blue capitalize submit-button"
                disabled={isLoading}
              >
                Send instructions
              </CustomButton>

              <div className="d-flex justify-content-center mt-4">
                <p className="card-anchor " onClick={() => navigate("/")}>
                  Back to login
                </p>
              </div>
            </Box>
          </FormProvider>
        )}
      </Box>
    </Box>
  );
}

export default ForgotPassword;
